const zh = { 
  header: {
    home: '首页',
    about: '品牌理念',
    stores: '门店分布',
    help: '帮助中心',
    members: '会员中心',
  }
}
export default zh